var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXrayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#A7A7A7;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M36.21,10.84,25.67,1.18A4.59,4.59,0,0,0,22.56,0H6.88A4.2,4.2,0,0,0,2.5,4V36a4.2,4.2,0,0,0,4.35,4H33.13a4.2,4.2,0,0,0,4.37-4V13.66A3.78,3.78,0,0,0,36.21,10.84ZM16.14,36.49l-3.49-5.34L9.16,36.49H5.89L11,28.67,6.21,21.31H9.46l3.19,4.88,3.19-4.88h3.25l-4.81,7.36,5.11,7.82ZM24.38,14a2.1,2.1,0,0,1-2.19-2V3l12,11Z",
    transform: "translate(-2.5 0)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXrayIcon);
export default __webpack_public_path__ + "static/media/xray_icon.bfc181171af592c001834fb1fea7fc15.svg";
export { ForwardRef as ReactComponent };